import * as React from 'react';
import { useState, useEffect } from 'react';
import createPersistedState from 'use-persisted-state';

import { useSelector, useDispatch } from 'react-redux';
import { colors } from "app/common/arctechv2/theme";

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

import useKeyPress from 'app/hooks/useKeyPress';

const componentCss = css`

	width: 400px;
	min-height: 400px;

	.site-menu-section-body {
		padding: var(--siteMenuSpacing);
	}
	
	.standard-dashboard {
		
		border: 0;
		padding: calc(.75rem + 1px) calc(1.5rem + 1px);
		display: inline-block;
		font-weight: 500;
		line-height: 1.5;
		text-align: center;
		vertical-align: middle;
		cursor: pointer;
		user-select: none;
		color: #7e8299;
		background-color: #f5f8fa;
		font-size: 1.1rem;
		border-radius: .475rem;
		transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
		text-decoration: none;

		&:hover {
			color: #7e8299;
			border-color: #e4e6ef;
			background-color: #e4e6ef;
		}

		margin-bottom: 20px;
	}

	.ClientSearch {
		width: 100%;
		height: 40px;
		padding: 0 10% 0 10px;
		font-weight: 700;
		border: none;
		background: transparent;
		font-size: 24px;
		color: #1BC5BD;
		transition: font-size 0.5s cubic-bezier(0.7,0,0.3,1);	

		margin-bottom: 10px;
		outline: none;
	}

	.ClientLogo {
		> img {
			height: 24px;
		}
	}
	
	.ClientClose {
		margin-left: auto;
	}

	.Client {
		background-color: #f5f8fa;
		border-radius: .475rem;
		margin-bottom: .5rem;
		align-items: center;
		display: flex;
		padding: .5rem;
		transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
		text-decoration: none;

		&:hover {
			color: #7e8299;
			border-color: #e4e6ef;
			background-color: #e4e6ef;
		}

		&.selected {
			color: #7e8299;
			border-color: #e4e6ef;
			background-color: #e4e6ef;
		}
	}

	.ClientLogo {
		display: inline-block;
		flex-shrink: 0;
		position: relative;
		border-radius: .475rem;
		margin-right: 1.25rem;
	}

	.ClientName {
		color: ${colors.darkNavy};
		transition: color .2s ease,background-color .2s ease;
		color: ${colors.darkNavy};
		font-weight: 600;
		font-size: 1.075rem;
	}

	.ClientDeliveries {
		color: ${colors.darkNavy};
	}

`;

export default React.forwardRef(({ selectedNav, isVisible, hideNav }, ref) => {

	const clients = useSelector(state => state.CLIENT_LIST);
	const useClientState = createPersistedState('selected-client');
	const [selectedClientId, setSelectedClientId] = useClientState(null);

	const [searchValue, setSearchValue] = useState('');
	const sv = searchValue?.toLowerCase();

	const search = React.useRef(null);

	useEffect(() => {
		if (isVisible) {
			search.current.focus()
		}
	}, [isVisible])

	const [cursor, setCursor] = useState(0);
	const isArrowUp = useKeyPress('ArrowUp');
	const isArrowDown = useKeyPress('ArrowDown');
	const isEnter = useKeyPress('Enter');

	const selectedClient = clients.items?.find(client => client.id === selectedClientId);

	const filteredItems = clients.items?.filter(client => client.name?.toLowerCase().indexOf(sv) > -1 || client.code?.toLowerCase().indexOf(sv) > -1).slice(0, 9);

	useEffect(() => {
		if (isVisible && filteredItems && isArrowDown) {
			setCursor(prevState =>
				prevState < filteredItems.length ? prevState + 1 : prevState
			);
		}
	}, [isVisible, isArrowDown]);

	useEffect(() => {
		if (isVisible && filteredItems && isArrowUp) {
			setCursor(prevState => (prevState > 0 ? prevState - 1 : prevState));
		}
	}, [isVisible, isArrowUp]);

	useEffect(() => {
		if (isVisible && filteredItems && isEnter && cursor > 1) {

			setSelectedClientId(filteredItems[cursor - 1].id);
			hideNav();
		}
	}, [isVisible, cursor, isEnter]);

	return <div css={componentCss} ref={ref} className={"SiteMenu__section " + (selectedNav == 0 ? "" : selectedNav > 1 ? "SiteMenu__section--left" : "")} hidden={selectedNav !== 1}>
		<section className="site-menu-section">
			<div className="site-menu-section-body">

				{selectedClient && <div className="Client nv-success-bg-light">
					<div className="ClientLogo">
						<img src={selectedClient.logoURI}></img>
					</div>
					<div className="d-flex flex-column">
						<span className="ClientName">{selectedClient.name}</span>
						<span className="ClientDeliveries">{selectedClient.code}</span>
					</div>
					<div onClick={() => {
						setSelectedClientId(null);
						hideNav();
					}} className="ClientClose fa-solid fa-times-circle"></div>
				</div>}

				<input onChange={e => {
					setCursor(0);
					if (selectedNav === 1) {
						setSearchValue(e.target.value);
					}
				}} ref={search} className="ClientSearch" placeholder="Search Clients..."></input>

				<div className="ClientList">
					{filteredItems?.map((client, i) => {
						return <div key={i} className={"Client" + (cursor === i + 1 ? ' selected' : '')} onClick={() => {
							setSelectedClientId(client.id);
							hideNav();
						}}>
							<div className="ClientLogo">
								<img src={client.logoURI}></img>
							</div>
							<div className="d-flex flex-column">
								<span className="ClientName">{client.name}</span>
								<span className="ClientDeliveries">{client.code}</span>
							</div>
						</div>
					})}
				</div>
			</div>
		</section>
	</div>

});
